import type { PermissionI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

class PermissionsApi extends BaseApi<PermissionI> {
  /**
   * `GET /api/permissions`
   * Obtener todos los permisos disponibles en el sistema.
   */
  async readAll() {
    const response = await fetchData<PermissionI[]>(`${this.endpoint}`, {
      method: 'GET',
    });
    return response;
  }
}

const permissionsApi = new PermissionsApi('/permissions');

export default permissionsApi;
